import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module6Nav = () => {
  const { module6 } = useSelector((state) => state.module6, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png';
    const mobileImage =
      '/Module6Images/Module6NavImages/Background_JourneyMap_Underwater.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(event.target),
      true
    );
  }, []);

  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    const filledImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}.png`;
    const outlinedImageUrl = `/Module6Images/Module6NavImages/Underwater_journeymap_Day${dayNumber}_1.png`;

    return {
      dayNumber,
      destiny: '/greet',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(8).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    song: 'appfiles/greet/greet_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module6.StudentID}/greet_celebration_surprise_5.mp4`,
      'appfiles/greet/greet_greeting_5.mp4',
      `userfiles/${module6.StudentID}/greet_practice_video_5.mp4`,
      `influencers/${login.influencerid}/greet_video_message.mp4`,
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module6.StudentID}/greet_celebration_surprise_6.mp4`,
      'appfiles/greet/greet_greeting_6.mp4',
      `userfiles/${module6.StudentID}/greet_practice_video_6.mp4`,
      `influencers/${login.influencerid}/greet_video_message.mp4`,
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module6.StudentID}/greet_celebration_surprise_7.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url, login))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE6'
          module={module6}
          days={DAYS_CONFIG}
          totalDays={8}
          unitDestiny='/unit2'
          nextDestiny='/unit2'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={2}
          animal={MediaService.getImage('/Images/Button_CrabHead.png', login)}
        />
      )}
    </>
  );
};
export default Module6Nav;
